import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

// Pass refreshKey as a prop
function DeviceFilterExtended({ refreshKey }) {
  const [maxNoise, setMaxNoise] = useState('');
  const [maxWeight, setMaxWeight] = useState('');
  const [minCooling, setMinCooling] = useState('');
  const [minSEER, setMinSEER] = useState('');
  const [selectedSystem, setSelectedSystem] = useState('');
  // Static unit types as the /api/unittypes endpoint is not implemented
  const [unitTypes, setUnitTypes] = useState(["Ścienny", "Kasetonowy", "Podstropowy", "Kanałowy"]);
  const [selectedUnitType, setSelectedUnitType] = useState('');
  
  const [devices, setDevices] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [error, setError] = useState('');

  const fetchDevices = useCallback(async (filterParams = {}) => {
    setError('');
    try {
      let url = '/devices'; // Corrected base URL to fetch all devices
      const queryParams = [];

      // Align frontend filter names with backend query parameter names
      if (filterParams.max_noise) queryParams.push(`halas_db_max=${filterParams.max_noise}`);
      if (filterParams.max_weight) queryParams.push(`waga_kg_max=${filterParams.max_weight}`);
      if (filterParams.min_cooling) queryParams.push(`moc_chlodnicza_kw_min=${filterParams.min_cooling}`);
      if (filterParams.min_SEER) queryParams.push(`seer_min=${filterParams.min_SEER}`);
      if (filterParams.system) queryParams.push(`typ_systemu=${filterParams.system}`);
      if (filterParams.unit_type) queryParams.push(`rodzaj_urzadzenia=${filterParams.unit_type}`);
      
      if (queryParams.length > 0) {
        url += '?' + queryParams.join('&');
      }

      const response = await axios.get(url);
      setDevices(response.data);
    } catch (err) {
      console.error("Błąd pobierania danych urządzeń:", err.response ? err.response.data : err.message);
      setError('Błąd pobierania danych urządzeń. Sprawdź konsolę.');
    }
  }, []);

  // Removed useEffect for /api/unittypes as it's not implemented and types are now static

  useEffect(() => {
    fetchDevices(); 
  }, [refreshKey, fetchDevices]);

  const handleFilter = () => {
    fetchDevices({
        max_noise: maxNoise,
        max_weight: maxWeight,
        min_cooling: minCooling,
        min_SEER: minSEER,
        system: selectedSystem,
        unit_type: selectedUnitType
    });
  };

  const toggleSelectDevice = (device) => {
    if (selectedDevices.find(d => d.id === device.id)) {
      setSelectedDevices(selectedDevices.filter(d => d.id !== device.id));
    } else {
      if (selectedDevices.length < 3) {
        setSelectedDevices([...selectedDevices, device]);
      } else {
        alert('Możesz wybrać maksymalnie 3 urządzenia.');
      }
    }
  };

  return (
    <div>
      <h2>Filtruj urządzenia (wewnętrzne)</h2>
      <div style={{ marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        <label>
          Maksymalny hałas (dB):
          <input
            type="number"
            value={maxNoise}
            onChange={(e) => setMaxNoise(e.target.value)}
            style={{ marginLeft: '0.5rem' }}
          />
        </label>
        <label>
          Maksymalna waga (kg):
          <input
            type="number"
            value={maxWeight}
            onChange={(e) => setMaxWeight(e.target.value)}
            style={{ marginLeft: '0.5rem' }}
          />
        </label>
        <label>
          Minimalna moc chłodnicza (kW):
          <input
            type="number"
            value={minCooling}
            onChange={(e) => setMinCooling(e.target.value)}
            style={{ marginLeft: '0.5rem' }}
          />
        </label>
        <label>
          Minimalny SEER:
          <input
            type="number"
            value={minSEER}
            onChange={(e) => setMinSEER(e.target.value)}
            style={{ marginLeft: '0.5rem' }}
          />
        </label>
        <label>
          System:
          <select value={selectedSystem} onChange={(e) => setSelectedSystem(e.target.value)} style={{ marginLeft: '0.5rem' }}>
            <option value="">-- Wybierz system --</option>
            <option value="Split">Split</option>
            <option value="MultiSplit">MultiSplit</option>
            <option value="VRF">VRF</option>
          </select>
        </label>
        <label>
          Typ jednostki:
          <select value={selectedUnitType} onChange={(e) => setSelectedUnitType(e.target.value)} style={{ marginLeft: '0.5rem' }}>
            <option value="">-- Wybierz typ --</option>
            {unitTypes.map((ut, index) => (
              <option key={index} value={ut}>
                {ut}
              </option>
            ))}
          </select>
        </label>
        <button onClick={handleFilter} style={{ marginLeft: '1rem' }}>Filtruj</button>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      
      <h3>Dostępne urządzenia:</h3>
      {devices.length === 0 && !error && <p>Brak urządzeń spełniających kryteria lub lista jest pusta.</p>}
      <ul>
        {Array.isArray(devices) && devices.map((device) => (
          <li key={device.id}>
            <input
              type="checkbox"
              checked={selectedDevices.some(d => d.id === device.id)}
              onChange={() => toggleSelectDevice(device)}
            />
            {device.producent} {device.model} – Hałas: {device.halas_db} dB, Waga: {device.waga_kg} kg, Moc chłodnicza: {device.moc_chlodnicza_kw} kW, SEER: {device.seer}, SCOP: {device.scop}, Wymiary: {`${device.szerokosc_mm}x${device.wysokosc_mm}x${device.glebokosc_mm}`}
          </li>
        ))}
      </ul>

      {selectedDevices.length > 0 && (
        <div>
          <h3>Porównanie wybranych urządzeń (wewnętrznych) wraz z agregatami:</h3>
          <table border="1" cellPadding="8" style={{width: '100%', marginTop: '20px'}}>
            <thead>
              <tr>
                <th>Producent</th>
                <th>Model jednostki</th>
                <th>Moc chłodnicza (kW)</th>
                <th>Moc grzewcza (kW)</th>
                <th>SEER</th>
                <th>SCOP</th>
                <th>Hałas (dB)</th>
                <th>Waga (kg)</th>
                <th>Wymiary (SxWxG mm)</th>
              </tr>
            </thead>
            <tbody>
              {selectedDevices.map((device) => (
                <tr key={device.id + "-selected"}>
                  <td>{device.producent}</td>
                  <td>{device.model}</td>
                  <td style={{ backgroundColor: 'lightgreen' }}>{device.moc_chlodnicza_kw}</td>
                  <td>{device.moc_grzewcza_kw}</td>
                  <td>{device.seer}</td>
                  <td>{device.scop}</td>
                  <td>{device.halas_db}</td>
                  <td>{device.waga_kg}</td>
                  <td>{`${device.szerokosc_mm}x${device.wysokosc_mm}x${device.glebokosc_mm}`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default DeviceFilterExtended;

